import { SidebarOption } from './CommonConsts';
/* サイドバー */
export var UserSidebarStatusEnum;
(function (UserSidebarStatusEnum) {
    UserSidebarStatusEnum[UserSidebarStatusEnum["MypageTop"] = 1] = "MypageTop";
    UserSidebarStatusEnum[UserSidebarStatusEnum["Message"] = 2] = "Message";
    UserSidebarStatusEnum[UserSidebarStatusEnum["Entry"] = 3] = "Entry";
    UserSidebarStatusEnum[UserSidebarStatusEnum["JobinfoEntry"] = 4] = "JobinfoEntry";
    UserSidebarStatusEnum[UserSidebarStatusEnum["RecruitmentEntry"] = 5] = "RecruitmentEntry";
    UserSidebarStatusEnum[UserSidebarStatusEnum["Favorite"] = 6] = "Favorite";
    UserSidebarStatusEnum[UserSidebarStatusEnum["Jobinfo"] = 7] = "Jobinfo";
    UserSidebarStatusEnum[UserSidebarStatusEnum["Recruitment"] = 8] = "Recruitment";
    UserSidebarStatusEnum[UserSidebarStatusEnum["Exam"] = 9] = "Exam";
    UserSidebarStatusEnum[UserSidebarStatusEnum["ExamHistory"] = 10] = "ExamHistory";
    UserSidebarStatusEnum[UserSidebarStatusEnum["Tool"] = 11] = "Tool";
    UserSidebarStatusEnum[UserSidebarStatusEnum["User"] = 12] = "User";
    UserSidebarStatusEnum[UserSidebarStatusEnum["Video"] = 13] = "Video";
})(UserSidebarStatusEnum || (UserSidebarStatusEnum = {}));
export const SidebarInfo = [
    {
        key: UserSidebarStatusEnum.MypageTop,
        title: 'マイページトップ',
        href: '/mypage/home',
    },
    {
        key: UserSidebarStatusEnum.Message,
        title: 'メッセージ',
        href: '/mypage/message_list',
    },
    {
        key: UserSidebarStatusEnum.Entry,
        title: 'エントリー中',
        option: SidebarOption.Accordion,
        children_array: [
            {
                key: UserSidebarStatusEnum.JobinfoEntry,
                title: "仕事エントリー一覧",
                href: "/mypage/entry/jobinfo/list"
            },
            {
                key: UserSidebarStatusEnum.RecruitmentEntry,
                title: "求人エントリー一覧",
                href: "/mypage/entry/recruitment/list"
            },
        ]
    },
    {
        key: UserSidebarStatusEnum.Favorite,
        title: 'お気に入り一覧',
        href: '/mypage/favorite_list',
    },
    {
        key: UserSidebarStatusEnum.Jobinfo,
        title: '仕事検索',
        href: '/mypage/jobinfo_list',
    },
    {
        key: UserSidebarStatusEnum.Recruitment,
        title: '求人検索',
        href: '/mypage/recruitment_list',
    },
    {
        key: UserSidebarStatusEnum.Exam,
        title: 'ランク認定試験',
        href: '/mypage/exam_top',
    },
    {
        key: UserSidebarStatusEnum.ExamHistory,
        title: '認定試験の結果を見る',
        href: '/mypage/exam_history',
    },
    {
        key: UserSidebarStatusEnum.Tool,
        title: '七つ道具(便利ツール)',
        href: '/tool/top',
        option: SidebarOption.Blank
    },
    {
        key: UserSidebarStatusEnum.User,
        title: '会員情報変更',
        href: '/mypage/user_detail',
    },
    {
        key: UserSidebarStatusEnum.Video,
        title: '現場の極意(動画購入)',
        href: '/mypage/video_pack_list',
    },
];
/* ユーザゲージ */
export var UserRankGageEnum;
(function (UserRankGageEnum) {
    UserRankGageEnum[UserRankGageEnum["GageNone"] = 0] = "GageNone";
    UserRankGageEnum[UserRankGageEnum["Gage1"] = 1] = "Gage1";
    UserRankGageEnum[UserRankGageEnum["Gage2"] = 2] = "Gage2";
    UserRankGageEnum[UserRankGageEnum["Gage3"] = 3] = "Gage3";
    UserRankGageEnum[UserRankGageEnum["Gage4"] = 4] = "Gage4";
    UserRankGageEnum[UserRankGageEnum["Gage5"] = 5] = "Gage5";
    UserRankGageEnum[UserRankGageEnum["Gage6"] = 6] = "Gage6";
    UserRankGageEnum[UserRankGageEnum["Gage7"] = 7] = "Gage7";
    UserRankGageEnum[UserRankGageEnum["Gage8"] = 8] = "Gage8";
    UserRankGageEnum[UserRankGageEnum["Gage9"] = 9] = "Gage9";
    UserRankGageEnum[UserRankGageEnum["Gage10"] = 10] = "Gage10";
    UserRankGageEnum[UserRankGageEnum["Gage11"] = 11] = "Gage11";
    UserRankGageEnum[UserRankGageEnum["Gage12"] = 12] = "Gage12";
    UserRankGageEnum[UserRankGageEnum["Gage13"] = 13] = "Gage13";
    UserRankGageEnum[UserRankGageEnum["Gage14"] = 14] = "Gage14";
    UserRankGageEnum[UserRankGageEnum["Gage15"] = 15] = "Gage15";
    UserRankGageEnum[UserRankGageEnum["Gage16"] = 16] = "Gage16";
    UserRankGageEnum[UserRankGageEnum["Gage17"] = 17] = "Gage17";
    UserRankGageEnum[UserRankGageEnum["Gage18"] = 18] = "Gage18";
    UserRankGageEnum[UserRankGageEnum["Gage19"] = 19] = "Gage19";
    UserRankGageEnum[UserRankGageEnum["Gage20"] = 20] = "Gage20";
    UserRankGageEnum[UserRankGageEnum["Gage21"] = 21] = "Gage21";
    UserRankGageEnum[UserRankGageEnum["Gage22"] = 22] = "Gage22";
    UserRankGageEnum[UserRankGageEnum["Gage23"] = 23] = "Gage23";
    UserRankGageEnum[UserRankGageEnum["Gage24"] = 24] = "Gage24";
    UserRankGageEnum[UserRankGageEnum["Gage25"] = 25] = "Gage25";
    UserRankGageEnum[UserRankGageEnum["Gage26"] = 26] = "Gage26";
    UserRankGageEnum[UserRankGageEnum["Gage27"] = 27] = "Gage27";
    UserRankGageEnum[UserRankGageEnum["Gage28"] = 28] = "Gage28";
    UserRankGageEnum[UserRankGageEnum["Gage29"] = 29] = "Gage29";
    UserRankGageEnum[UserRankGageEnum["Gage30"] = 30] = "Gage30";
    UserRankGageEnum[UserRankGageEnum["Gage31"] = 31] = "Gage31";
    UserRankGageEnum[UserRankGageEnum["Gage32"] = 32] = "Gage32";
    UserRankGageEnum[UserRankGageEnum["Gage33"] = 33] = "Gage33";
    UserRankGageEnum[UserRankGageEnum["Gage34"] = 34] = "Gage34";
    UserRankGageEnum[UserRankGageEnum["Gage35"] = 35] = "Gage35";
    UserRankGageEnum[UserRankGageEnum["Gage36"] = 36] = "Gage36";
})(UserRankGageEnum || (UserRankGageEnum = {}));
// スコアとゲージの対応
export const UserRankGageScoreMatrix = [
    { range: { min: 0, max: 0 }, gage: UserRankGageEnum.GageNone },
    { range: { min: 1, max: 7 }, gage: UserRankGageEnum.Gage1 },
    { range: { min: 8, max: 14 }, gage: UserRankGageEnum.Gage2 },
    { range: { min: 15, max: 21 }, gage: UserRankGageEnum.Gage3 },
    { range: { min: 22, max: 26 }, gage: UserRankGageEnum.Gage4 },
    { range: { min: 27, max: 33 }, gage: UserRankGageEnum.Gage5 },
    { range: { min: 34, max: 40 }, gage: UserRankGageEnum.Gage6 },
    { range: { min: 41, max: 43 }, gage: UserRankGageEnum.Gage7 },
    { range: { min: 44, max: 47 }, gage: UserRankGageEnum.Gage8 },
    { range: { min: 48, max: 51 }, gage: UserRankGageEnum.Gage9 },
    { range: { min: 52, max: 55 }, gage: UserRankGageEnum.Gage10 },
    { range: { min: 56, max: 59 }, gage: UserRankGageEnum.Gage11 },
    { range: { min: 60, max: 63 }, gage: UserRankGageEnum.Gage12 },
    { range: { min: 64, max: 67 }, gage: UserRankGageEnum.Gage13 },
    { range: { min: 68, max: 70 }, gage: UserRankGageEnum.Gage14 },
    { range: { min: 71, max: 72 }, gage: UserRankGageEnum.Gage15 },
    { range: { min: 73, max: 73 }, gage: UserRankGageEnum.Gage16 },
    { range: { min: 74, max: 74 }, gage: UserRankGageEnum.Gage17 },
    { range: { min: 75, max: 76 }, gage: UserRankGageEnum.Gage18 },
    { range: { min: 77, max: 77 }, gage: UserRankGageEnum.Gage19 },
    { range: { min: 78, max: 79 }, gage: UserRankGageEnum.Gage20 },
    { range: { min: 80, max: 80 }, gage: UserRankGageEnum.Gage21 },
    { range: { min: 81, max: 82 }, gage: UserRankGageEnum.Gage22 },
    { range: { min: 83, max: 83 }, gage: UserRankGageEnum.Gage23 },
    { range: { min: 84, max: 84 }, gage: UserRankGageEnum.Gage24 },
    { range: { min: 85, max: 86 }, gage: UserRankGageEnum.Gage25 },
    { range: { min: 87, max: 87 }, gage: UserRankGageEnum.Gage26 },
    { range: { min: 88, max: 88 }, gage: UserRankGageEnum.Gage27 },
    { range: { min: 89, max: 90 }, gage: UserRankGageEnum.Gage28 },
    { range: { min: 91, max: 91 }, gage: UserRankGageEnum.Gage29 },
    { range: { min: 92, max: 93 }, gage: UserRankGageEnum.Gage30 },
    { range: { min: 94, max: 94 }, gage: UserRankGageEnum.Gage31 },
    { range: { min: 95, max: 95 }, gage: UserRankGageEnum.Gage32 },
    { range: { min: 96, max: 97 }, gage: UserRankGageEnum.Gage33 },
    { range: { min: 98, max: 98 }, gage: UserRankGageEnum.Gage34 },
    { range: { min: 99, max: 99 }, gage: UserRankGageEnum.Gage35 },
    { range: { min: 100, max: 100 }, gage: UserRankGageEnum.Gage36 },
];
//求人一覧の検索欄
export var sortRecruitmentListEnum;
(function (sortRecruitmentListEnum) {
    sortRecruitmentListEnum[sortRecruitmentListEnum["Payment"] = 1] = "Payment";
    sortRecruitmentListEnum[sortRecruitmentListEnum["Deadline"] = 2] = "Deadline";
    sortRecruitmentListEnum[sortRecruitmentListEnum["Latest"] = 3] = "Latest";
})(sortRecruitmentListEnum || (sortRecruitmentListEnum = {}));
//仕事一覧の検索欄
export var sortJobListEnum;
(function (sortJobListEnum) {
    sortJobListEnum[sortJobListEnum["Payment"] = 1] = "Payment";
    sortJobListEnum[sortJobListEnum["Deadline"] = 2] = "Deadline";
    sortJobListEnum[sortJobListEnum["Latest"] = 3] = "Latest";
})(sortJobListEnum || (sortJobListEnum = {}));
export var CompanyDetailReferrerEnum;
(function (CompanyDetailReferrerEnum) {
    CompanyDetailReferrerEnum["JobinfoDetail"] = "/mypage/jobinfo_detail";
    CompanyDetailReferrerEnum["RecritmentDetail"] = "/mypage/recruitment_detail";
})(CompanyDetailReferrerEnum || (CompanyDetailReferrerEnum = {}));
